import ManageAddresses from "./ManageAddresses";
export default  ManageAddresses;